
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-04-21 (1.0.0) (jhoward)
 *    - Copy from Bimini_default.vue component to HighLimit_default.vue component.
 *
 *  2023-06-19 (1.1.0) (jhoward)
 *    - Support section.ms_show_pricing_header in <HighLimit_defaultSection>.
 *
 *  2023-08-23 (1.2.0) (jhoward)
 *    - Use <menu-version> in <HighLimit_defaultSection>.
 *
 *  2025-02-11 (1.3.0) (jhoward)
 *    - Add <menu-schedules> to the <HighLimit_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <HighLimit_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <HighLimit_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "HighLimit_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
